<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['values', 'labels'],
  data () {
    return {
      style: {
        height: `40px`,
        position: 'relative'
      },
      data: {
        labels: this.labels, // xlabels
        datasets: [
          {
            label: '2019 June Data Entries #',
            borderColor: '#069BFF',
            backgroundColor: '#069BFF',
            data: this.values
          }
        ]
      },
      options: {
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              stepSize: 1,
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Number of Interventions'
            }
          }],
          xAxes: [{
            ticks: {
              callback: (value, index, values) => {
                return (new Date(value * 1000)).toLocaleDateString(
                  'en-US', { day: 'numeric', month: 'long' }
                )
              }
            }
          }]
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.data, this.options)
  }
}
</script>

style
